export const VIEWBOX_WIDTH = 100
export const VIEWBOX_HEIGHT = 100
export const VIEWBOX_X1 = 0
export const VIEWBOX_X2 = 100
